export default __webpack_public_path__ + "static/N0073-528cb6ec5ab45cc95cfecea49757d83a.png";